'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProcessNodes;

var _elementTypes = require('../elementTypes');

var _elementTypes2 = _interopRequireDefault(_elementTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Tests a htmlparser2 node and returns whether is it a text node at the start and end of the line containing only
 * white space. This allows these node types to be excluded from the rendering because they are unnecessary.
 *
 * @param {Object} node The element object as created by htmlparser2
 * @returns {boolean} Whether
 */
var filterOutEmptyTextNodes = function filterOutEmptyTextNodes(node) {
  return !(node.type === 'text' && /\r?\n/.test(node.data) && node.data.trim() === '');
};

/**
 * Converts a htmlparser2 node to a React element
 *
 * @param {Object} node The htmlparser2 node to convert
 * @param {Number} index The index of the current node
 * @returns {React.Element}
 */
var convertNodeToElement = function convertNodeToElement(node, index) {
  var key = 'rhp-' + index;
  return _elementTypes2.default[node.type](node, key);
};

/**
 * Processes the nodes generated by htmlparser2 and convert them all into React elements
 *
 * @param {Object[]} nodes List of nodes to process
 * @returns {React.Element[]} The list of processed React elements
 */
function ProcessNodes(nodes) {

  return nodes.filter(filterOutEmptyTextNodes).map(function (node, index) {
    return convertNodeToElement(node, index);
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/react-html-parser/lib/utils/ProcessNodes.js
// module id = 294
// module chunks = 0